import { ReactElement } from 'react';

import { Navigate, Outlet } from 'react-router-dom';

import { ROUTE } from '@/constants/route';

interface RequireVersementSessionProps {
  children?: ReactElement;
}

/**
 * Guards the "parcours de versement" terminal pages (succès, annulation, échec, erreur).
 * Unlike the wizard steps, these are also reached without navigation state — success in
 * particular comes back from an external redirect (Universign) carrying only a `?token=`
 * query param. sessionStorage's `parcoursVersementData` survives that redirect, so it is
 * used here instead of `location.state` to detect an ongoing deposit flow.
 */
const RequireVersementSession: React.FC<RequireVersementSessionProps> = ({ children }) => {
  if (!sessionStorage.getItem('parcoursVersementData')) {
    return <Navigate to={ROUTE.DASHBOARD} replace />;
  }

  return children ?? <Outlet />;
};

export default RequireVersementSession;
